// extracted by mini-css-extract-plugin
export var feeComparison = "style-module--feeComparison--de699";
export var feeTable = "style-module--feeTable--24f8b";